module.exports = __webpack_public_path__ + "img/icon79.ec622b69.png";